import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface WelcomeOnboardingProps {
  title?: string;
  subtitle?: string;
}

const WelcomeOnboarding: React.FC<WelcomeOnboardingProps> = ({ title, subtitle }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(245, 166, 35, 0.12)' : 'rgba(11, 107, 203, 0.08)',
          mb: 3,
        }}
      >
        <ShieldCheck size={36} color={theme.palette.primary.main} />
      </Box>
      <Typography variant="h4" fontWeight={700}>
        {title ?? t('welcome.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5, maxWidth: 480 }}>
        {subtitle ?? t('welcome.subtitle')}
      </Typography>
      <Button
        variant="contained"
        size="large"
        sx={{ mt: 4, px: 4 }}
        onClick={() => navigate('/onboarding/new')}
      >
        {t('welcome.register')}
      </Button>
    </Box>
  );
};

export default WelcomeOnboarding;
